module.exports = __webpack_public_path__ + "img/404.08c1a22a.svg";